import Vue from 'vue';
import Vuex from 'vuex';
import Store from '@/stores';

Vue.use(Vuex);

export default new Vuex.Store({
	strict: process.env.NODE_ENV === 'development',
	modules: Store
});